import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DeviceStatus } from '../../models/device-status';

type DeviceStatusPresentation = {
  badgeClass: string;
  labelKey: string;
};

const BADGE_CLASS_BY_STATUS: Record<DeviceStatus, string> = {
  [DeviceStatus.STOCKED]: 'text-bg-info',
  [DeviceStatus.DELIVERED]: 'text-bg-success',
  [DeviceStatus.PENDING_RETURN]: 'text-bg-warning',
  [DeviceStatus.DECOMMISSIONED]: 'text-bg-secondary',
  [DeviceStatus.BROKEN]: 'text-bg-danger',
  [DeviceStatus.MISSING]: 'device-status-missing',
};

@Component({
  standalone: true,
  selector: 'app-device-status-badge',
  imports: [TranslatePipe],
  styles: `
    .device-status-missing {
      background-color: #ff8400;
      color: #212529;
    }
  `,
  template: `
    @if (presentation(); as presentation) {
      <span class="badge rounded-pill" [class]="presentation.badgeClass">
        {{ presentation.labelKey | translate }}
      </span>
    } @else {
      -
    }
  `,
})
export class DeviceStatusBadgeComponent {
  readonly status = input<DeviceStatus | null | undefined>();

  readonly translationKeyPrefix = input.required<string>();

  readonly managerView = input(false);

  protected readonly presentation = computed<
    DeviceStatusPresentation | undefined
  >(() => {
    const status = this.status();
    if (!status || !BADGE_CLASS_BY_STATUS[status]) {
      return undefined;
    }

    if (
      this.managerView() &&
      ![
        DeviceStatus.PENDING_RETURN,
        DeviceStatus.MISSING,
        DeviceStatus.BROKEN,
      ].includes(status)
    ) {
      return {
        badgeClass: 'text-bg-success',
        labelKey: 'batteryPrediction.statusValues.OK',
      };
    }

    return {
      badgeClass: BADGE_CLASS_BY_STATUS[status],
      labelKey: `${this.translationKeyPrefix()}.${status}`,
    };
  });
}
